import { render, staticRenderFns } from "./AnxButton.vue?vue&type=template&id=4d673718&scoped=true&"
import script from "./AnxButton.vue?vue&type=script&lang=ts&"
export * from "./AnxButton.vue?vue&type=script&lang=ts&"
import style0 from "./AnxButton.vue?vue&type=style&index=0&id=4d673718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d673718",
  null
  
)

export default component.exports